// extracted by mini-css-extract-plugin
export var dataCell = "_ln-2";
export var dataRow = "_ln-0";
export var headerRow = "_ln-1";